import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Coins, Check, X } from 'lucide-react';

/**
 * Inline-banner som visas när AI-output har stage:ats som temp-layer.
 * User trycker Apply → layer flippas permanent + credits deductas.
 * User trycker Discard → layer försvinner + reservation släpps.
 */
export interface AiCostPreviewCardProps {
  proposalName: string;
  costCredits: number;
  balanceBefore: number;
  onApply: () => void;
  onDiscard: () => void;
  pending?: boolean;
}

export function AiCostPreviewCard({
  proposalName, costCredits, balanceBefore, onApply, onDiscard, pending,
}: AiCostPreviewCardProps) {
  const balanceAfter = balanceBefore - costCredits;
  return (
    <div className="border border-violet-300 bg-violet-50 dark:bg-violet-950/30 rounded-lg p-3 space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Coins className="w-4 h-4 text-violet-600" />
          <span className="text-sm font-semibold">{proposalName}</span>
        </div>
        <Badge variant="outline" className="border-violet-400 text-violet-700 dark:text-violet-300">
          {costCredits} ai credits
        </Badge>
      </div>
      <div className="text-xs text-muted-foreground">
        Preview i lila layer på canvas. Apply → deduct:ar credits +
        permanentar ändringar. Discard → återställer canvas + släpper
        reservation. <br />
        Balans: <strong>{balanceBefore}</strong> → <strong>{balanceAfter}</strong> efter apply.
      </div>
      <div className="flex gap-2 justify-end">
        <Button
          size="sm"
          variant="outline"
          onClick={onDiscard}
          disabled={pending}
        >
          <X className="w-3.5 h-3.5 mr-1" /> Discard
        </Button>
        <Button
          size="sm"
          onClick={onApply}
          disabled={pending}
        >
          <Check className="w-3.5 h-3.5 mr-1" /> Apply ({costCredits} credits)
        </Button>
      </div>
    </div>
  );
}
